<template>
    <BreadCrumb PageTitle="Liste des Ventes" />
    <ListeVente />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeVente from "../../components/Vente/ListeVente.vue";

    export default defineComponent({
        name: "ListeVentePage",
        components: {
            BreadCrumb,
            ListeVente,
        },
    });
</script>